import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Services from '@/views/Services.vue'
import CosmeticServices from '@/views/services/CosmeticServices.vue'
import FixedServices from '@/views/services/FixedServices.vue'
import ImplantServices from '@/views/services/ImplantServices.vue'
import SurgicalGuides from '@/views/services/SurgicalGuides.vue'
import RemovableServices from '@/views/services/RemovableServices.vue'
import About from '@/views/About.vue'
import Contact from '@/views/Contact.vue'
import Gallery from '@/views/Gallery.vue'
import FXform from '@/views/RXform.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/services',
    name: 'Services',
    component: Services
  },
  {
    path: '/services/cosmetic',
    name: 'CosmeticServices',
    component: CosmeticServices
  },
  {
    path: '/services/fixed',
    name: 'FixedServices',
    component: FixedServices
  },
  {
    path: '/services/implant',
    name: 'ImplantServices',
    component: ImplantServices
  },
  {
    path: '/services/surgical-guides',
    name: 'SurgicalGuides',
    component: SurgicalGuides
  },
  {
    path: '/services/removable',
    name: 'RemovableServices',
    component: RemovableServices
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: Gallery
  },
  {
    path: '/RXform',
    name: 'RXform',
    component: FXform
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router